<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill="#DA4E4E"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.85591 3.66189L8.57591 9.96189H7.00791L6.71391 3.66189H8.85591ZM8.92587 12.0198C8.92587 12.6218 8.40787 13.1398 7.79187 13.1398C7.17587 13.1398 6.67188 12.6218 6.67188 12.0198C6.67188 11.4038 7.17587 10.8858 7.79187 10.8858C8.40787 10.8858 8.92587 11.4038 8.92587 12.0198Z" fill="white"/>
    </svg>
</template>

<script>
export default {
    name: 'article-icon'
}
</script>